// imports
import Model from '$dependencies/Model';
// private static properties
export const FIELDS = {
    uuid: { type: String, default: '', identifier: true },
    title: { type: String, default: '' },
    emailAddresses: { type: Array, default: () => [] },
    communities: { type: Array, default: () => [] },
	//extra fields for select
    label: { type: String, default: '' },
    name: { type: String, default: '' },
    value: { type: String, default: '' },
    id: { type: String, default: '' },
};

// class definition
export default class IncidentTeam extends Model {
    // constructor
    constructor(args = {}) {
        // clone args to do some modifications
        args = Object.assign({}, args);
        args.fields = FIELDS;
        // call super constructor
        super(args);
    }

    // methods
    destroy() {}
}
